module.exports = __webpack_public_path__ + "img/ascher.e4a7d80c.jpg";